/**
 * Enum representing the different application names in the MobilityCare platform.
 */
export enum AppName {
  MobilityCare = "MobilityCare",
  MobilityCareAfrica = "MobilityCare Africa",
  NatalConnect = "NatalConnect",
  Dispatch = "Dispatch",
  Admin = "Admin",
}
